/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import "./ExtrasFieldsPopup.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, withTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { bindActionCreators } from "redux";
import TextInput from "../TextInput/TextInput";
import InputMaskField from "../react-input-mask/inputfield";
import TextArea from "../TextArea/TextArea";
import { Skeleton } from "@material-ui/lab";
import Avatar from "@mui/material/Avatar";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import AWS from "aws-sdk";

import { IconButton } from "@material-ui/core";
import RadioInput from "../RadioInput/RadioInput";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers";
import { get_lang } from "../../helper/getLang";
import CheckBoxInput from "../checkBoxInput/checkBoxInput";
import { convertStringToArray } from "../../helper/extasfieldfunctions";


const ExtrasFieldsPopup = (props: any) => {
  const { handleIncrement, handleDecrement, currentCart,setTempCart } = props;
  const state = useSelector((state: RootState) => state.appReducer);
  const { cart } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);
  const { extrasFields } = appState;
  const { langValue } = state;
  const [values, setValues]: any = useState([]);
  // const [url, seturl] = useState(null)

  const dispatch = useDispatch();
  const { setExtrasFieldsPopup, setCart, freezScreenState } =
    bindActionCreators(actionCreators, dispatch);
  const { t } = useTranslation();

  const handleAddtoCart = async (e: any) => {
    e.preventDefault();
    let thisCard = cart.find(
      (element: any) =>
        element?.booking_extra_id == currentCart?.booking_extra_id
    );
    if (thisCard) {
      let cartContent = { ...currentCart, values: values };
      const existingObjectIndex = cart.findIndex(
        (item: any) => item.booking_extra_id === currentCart?.booking_extra_id
        );
      let localcart = (await cart) ? [...cart] : [];
      localcart[existingObjectIndex] = cartContent;
      setTempCart(localcart);
      setExtrasFieldsPopup(false);
      freezScreenState(false);
    } else {
      let cartContent = { ...currentCart, values: values };
      let localcart = (await cart) ? [...cart] : [];
      localcart = [...localcart, cartContent];
      setTempCart(localcart);
      setExtrasFieldsPopup(false);
      freezScreenState(false);
    }
  };

  const handleFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const { name }: any = file;
    const s3 = new AWS.S3({
      accessKeyId: process.env.REACT_APP_APP_AWSAccessKeyId as string,
      secretAccessKey: process.env.REACT_APP_APP_AWSSecretKey as string,
    });
    const params: any = {
      Bucket: process.env.REACT_APP_APP_AWS_S3_BUCKET,
      Key: name,
      Body: e.target.value,
    };
    s3.upload(params, (err: any, data: any) => {
      if (err) {
        console.error("Error uploading file:", err);
      } else {
        const value = data.Location;
        const [type, idStr, index] = e.target.name.split("_");
        const id = parseInt(idStr);

        const existingObjectIndex = values?.findIndex(
          (item: any) => item.index === index && item.type === type
        );
        const updatedValues = values?.length > 0 ? [...values] : [];

        if (existingObjectIndex !== -1) {
          updatedValues[existingObjectIndex] = {
            ...updatedValues[existingObjectIndex],
            value,
          };
        } else {
          updatedValues.push({ id, type, value, index }); // Include type when adding a new object
        }
        setValues(updatedValues);
      }
    });
  };

  const updateField = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const [type, idStr, index] = name.split("_");
    const id = parseInt(idStr);

    const existingObjectIndex = values?.findIndex(
      (item: any) => item.index === index && item.type === type
    );
    const updatedValues = values?.length > 0 ? [...values] : [];

    if (existingObjectIndex !== -1) {
      updatedValues[existingObjectIndex] = {
        ...updatedValues[existingObjectIndex],
        value,
      };
    } else {
      updatedValues.push({ id, type, value, index }); // Include type when adding a new object
    }
console.log(updatedValues);
    setValues(updatedValues);
  };

  const handleCheckbox = (value: any, name: any) => {
    const [type, idStr, index] = name.split("_");
    const id = parseInt(idStr);
    const existingObjectIndex = values?.findIndex(
      (item: any) => item.index === index && item.type === type
    );
    const updatedValues = values?.length > 0 ? [...values] : [];

    if (existingObjectIndex !== -1) {
      let customeData: any = {
        id,
        type,
        value,
        index,
      };
      updatedValues[existingObjectIndex] = customeData;
    } else {
      let customeData: any = {
        id,
        type,
        value,
        index,
      };
      updatedValues.push(customeData);
    }
    setValues(updatedValues);
  };



  useEffect(() => {
    const handleFirstRender = () => {
      let thisCard = cart.find(
        (element: any) =>
          element?.booking_extra_id == currentCart?.booking_extra_id
      );
      setValues(thisCard?.values ? thisCard?.values : []);
    };
    handleFirstRender();
  }, [currentCart, cart]);

  return (
    <React.Fragment>
      <div
        id="mySidenav"
        className={`ExtrasFieldsPopup px-3  py-3 
        ${langValue === "ar" ? "paymentMethodsl1Arabic" : ""}`}
      >
        {!currentCart ? (
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <Skeleton height={200} />
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="row mt-2 mx-0 d-flex align-items-center justify-content-center">
              <Avatar
                variant="square"
                style={{ alignSelf: "center" }}
                className={`featuredProductImage  ${
                  appState.langValue === "ar" ? "" : ""
                } `}
                src={currentCart?.image ? `${currentCart?.image}` : ``}
              ></Avatar>
            </div>
            <div className="d-flex flex-column my-2  w-100">
              {currentCart?.prod_title != null ? (
                <div className="p-0 px-2  d-flex flex-column justify-content-end ">
                  <h5 className="d-flex text-capitalize">
                    {currentCart?.prod_title != null
                      ? get_lang(currentCart?.prod_title, appState.langValue)
                      : "Name is not available"}
                  </h5>
                </div>
              ) : (
                <div className="row m-0 mb-4 mt-3 d-flex flex-row">
                  <div className="col-6  ">
                    <Skeleton height={50} />
                  </div>
                  <div className="col-10 ">
                    <Skeleton height={50} />
                  </div>
                  <div className="col-3 ">
                    <Skeleton height={50} />
                  </div>
                </div>
              )}
            </div>
            <div className="row m-0 mt-3">
              <div className="prod-single col-12 p-0">
                {currentCart ? (
                  <div
                    className={
                      appState.langValue == "ar"
                      ? "d-flex  justify-content-end"
                        : "d-flex justify-content-end"
                    }
                  >
                    <React.Fragment>
                      {" "}
                      {currentCart.quantity <= 0 &&
                      currentCart.quantity != null ? (
                        <p
                          style={{ color: "red", fontSize: "14px" }}
                          className=" d-flex m-0"
                        >
                          {t("single-product.Out-of-stock")}
                        </p>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                    <h4 className="m-0 ">
                      <strong>
                        {
                          <React.Fragment>
                            {(currentCart.price * currentCart.quantity).toFixed(3)}
                            <span className="thinBold ">
                              &nbsp;
                              {get_lang(
                                appState.storeInfo.storeCurrency,
                                appState.langValue
                              )}
                            </span>
                          </React.Fragment>
                        }
                      </strong>{" "}
                    </h4>
                  </div>
                ) : (
                  <span></span>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
        <form className="py-2"  onSubmit={handleAddtoCart} >
          {extrasFields?.map((field: any, ind: any) => {
            return field.type.id == 1 ? (
              <div className="my-2">
                <TextInput
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  name={`textBox_${field.type.id}_${ind}`}
                  type="text"
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                  options={field?.options}
                />
              </div>
            ) : field.type.id == 2 ? (
              <div className="my-2">
                <TextArea
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  name={`textArea_${field.type.id}_${ind}`}
                  type="text"
                  options={field.options}
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                />
              </div>
            ) : field.type.id == 3 ? (
              <div className="my-2">
                <InputMaskField
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  onChange={updateField}
                  inputProps={{ inputMode: "numeric" }}
                  label={get_lang(field.name, langValue)}
                  className="mt-2"
                  variant="outlined"
                  type="tel"
                  mask="99999999"
                  id="outlined-basic"
                  name={`number_${field.type.id}_${ind}`}
                />
              </div>
            ) : field.type.id == 4 ? (
              "" ///select
            ) : field.type.id == 5 ? (
              <div className="my-2">
                <RadioInput
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  data={field.options}
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  name={`radioButtonField_${field.type.id}_${ind}`}
                  type="radio"
                  placeholder={get_lang(field.description, langValue)}
                />
              </div>
            ) : field.type.id == 6 ? (
              <div className="my-2">
                <TextInput
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  name={`date_${field.type.id}_${ind}`}
                  type="date"
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                  options={field?.options}
                />
              </div>
            ) : field.type.id == 7 ? (
              <div className="my-2">
                <TextInput
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  name={`datetime_${field.type.id}_${ind}`}
                  type="datetime-local"
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                  options={field?.options}
                />
              </div>
            ) : field.type.id == 8 ? (
              <div className="my-2">
                <TextInput
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  name={`time_${field.type.id}_${ind}`}
                  type="time"
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                  options={field?.options}
                />
              </div>
            ) : field.type.id == 9 ? (
              <div className="my-2">
                <TextInput
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  name={`url_${field.type.id}_${ind}`}
                  type="url"
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                  options={field?.options}
                />
              </div>
            ) : field.type.id == 10 ? (
              <div className="my-2">
                <TextInput
                  value={
                    values?.find((obj: any) => obj.index == ind)?.value || ""
                  }
                  label={get_lang(field.name, langValue)}
                  handlechange={updateField}
                  name={`color_${field.type.id}_${ind}`}
                  type="color"
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                  options={field?.options}
                />
              </div>
            ) : field.type.id == 11 ? (
              <div className="my-2">
                <TextInput
                  // value={values?.find((obj:any) => obj.index == ind)?.value || ''}
                  label={get_lang(field.name, langValue)}
                  handlechange={handleFiles}
                  name={`fileUpload_${field.type.id}_${ind}`}
                  type="file"
                  placeholder={get_lang(field.description, langValue)}
                  required={field?.required}
                  options={field?.options}
                />
              </div>
            ) : field.type.id == 12 ? (
              <div className="my-2">
                <CheckBoxInput
                  label={get_lang(field.name, langValue)}
                  name={`CheckBoxInput_${field.type.id}_${ind}`}
                  placeholder={get_lang(field.description, langValue)}
                  data={convertStringToArray(field.options?.values)}
                  handleCheckbox={handleCheckbox}
                  found={values?.find((element: any) => element?.index == ind)}
                />
              </div>
            ) : (
              ""
            );
          })}
          <div className="btnFixedClassOnfield col-md-6 col-sm-12  position-fixed ">
           <span className="Addbutton">
                {currentCart.quantity > 1 ? (
                  <IconButton
                    id="IncDecItemQuan"
                    size="small"
                    className="qtyBtn"
                    onClick={() => handleDecrement(currentCart)}
                  >
                    <RemoveIcon />
                  </IconButton>
                ) : (
                  <IconButton id="IncDecItemQuan" size="small" disabled>
                    <RemoveIcon />
                  </IconButton>
                )}

              <span
                style={{
                  fontSize: "1rem",
                  padding: "15px",
                }}
              >
                {currentCart.quantity}
              </span>

            
                <IconButton
                  id="IncDecItemQuan"
                  size="small"
                  onClick={() => handleIncrement(currentCart)}
                  disabled={currentCart.quantity == currentCart.maxQuantity}
                  className={`${
                    currentCart.quantity == currentCart.maxQuantity ? "" : "qtyBtn"
                  }`}
                >
                  <AddIcon />
                </IconButton>
              </span>

            <Button
              type="submit"
              id="addToCartBtn"
              variant="contained"
              className="   text-capitalize d-flex "
            >
              Add to cart
            </Button>
          </div>
        </form>

        {/* <div className="my-2">
                      <SelectField
                        data={field.options}
                        label={get_lang(field.name, langValue)}
                        name={`selectInput_${field.type.id}_${ind}`}
                        placeholder={get_lang(field.description, langValue)}
                        multiple={Boolean(field.options.multiple)}
                        handleSelectField={handleSelectField}
                      />
                    </div> */}
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ExtrasFieldsPopup);
